function FranceInterFooter() {
    const telephoneLink = 'tel:0145247000';
    const telephoneShow = '01 45 24 7000';
    const telephoneWhatsapp = 'https://wa.me/145247000';
    return (
        <>
            <div className="fi-footer">
                <img src="../../FranceInter/logo_france_inter.svg" alt="Logo du France Inter, Carre rouge avec ecrit en blanc en bas du carré : France inter" />
                <div>
                    <p className='imageFI'> Standard France Inter</p>
                    <p className='contact-link'>  → <a href={telephoneLink} target="_blank" alt="ouvre l'application pour appeler le standard de France Inter">{telephoneShow} </a></p>
                    <p className='contact-link'>  → <a href={telephoneWhatsapp} target="_blank" alt="ouvre l'application whatsapp pour appeler le standard de France Inter">WhatsApp</a></p>
                </div>
            </div>

        </>
    );
}

export default FranceInterFooter;